export const productShortName = 'Lithium & Critical Minerals — Professional Edition™';
export const productBrand = 'Lithium & Critical Minerals';
export const productEdition = 'Professional Edition™';
export const productTagline = 'Master Professional Mining & Materials Knowledge in One Complete Learning Experience.';
export const productImage = 'https://cdn.magicpatterns.com/uploads/csgEpeGuBzMe7BsMRw4NZ8/MOCKUP_2.58.14_p._m..png';

export const checkoutUrl = 'https://lithium-critical-minerals.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const closingLines = [
  'No more confusion about lithium deposits and geology',
  'No more uncertain technical explanations to colleagues',
  'No more struggling with extraction and refining concepts',
  'No more gaps in understanding battery materials',
  "No more limited career advancement because technical knowledge isn't documented",
];
